import { render, staticRenderFns } from "./KycDetails.vue?vue&type=template&id=f64c158e&scoped=true&"
import script from "./KycDetails.vue?vue&type=script&lang=js&"
export * from "./KycDetails.vue?vue&type=script&lang=js&"
import style0 from "./KycDetails.vue?vue&type=style&index=0&id=f64c158e&scoped=true&lang=css&"
import style1 from "./KycDetails.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f64c158e",
  null
  
)

export default component.exports